import React, { ReactNode } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  isMobile: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  isMobile,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      {/* Dimmer */}
      <div
        className={`absolute inset-0 ${isMobile ? "bg-white" : ""}`}
        style={isMobile ? {} : { background: "rgba(0, 0, 0, 0.60)" }}
      />

      {/* Modal Content */}
      <div
        className={`relative z-10 bg-white ${
          isMobile
            ? "w-full h-full"
            : "rounded-[24px] max-h-[90vh] overflow-scroll"
        }`}
        style={isMobile ? {} : { width: "960px" }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};
